import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        windowHeight:'',
        userObj:{},
        // localUrl:'http://192.168.1.10:8088',
         localUrl:'http://support-preprod.huhtaonline.com/'
    },
    getters: {
        currentUser(state) {
            return state.currentUser;
        },

        getToken(state) {
            if(!state.token) {
                state.token = localStorage.getItem("token");
            }
            return state.token
        }
    },
    mutations: {
        setUserInfo(state, user) {
            state.userObj = user;
        },
        setWindowH(state,height){
            state.windowHeight = height;
        },//获取最大高度

        //存储token方法
        //设置token等于外部传递进来的值
        setToken(state, token) {
            state.token = token
            localStorage.token = token //同步存储token至localStorage
        }
    },
    actions: {
        setUser({ commit }, user) {
            commit("setUserInfo", user)
        },
        setWinH({commit},h){
            commit("setWindowH",h)
        },
        setAuthToken({commit},token) {
            commit("setToken",token)
        }
    }
});
export default store;